/**
 * DÉPRÉCIÉ : Redirige vers UnifiedSocketService
 */
import socketService from './unifiedSocketService';
export default {
    connect: () => socketService.connect(),
    disconnect: () => socketService.disconnect(),
    isConnected: () => socketService.isSocketConnected(),
    getSocket: () => socketService.getSocket(),
    getConnectionInfo: () => socketService.getConnectionStats()
};
